import {defineStore} from "pinia";
import {useNuxtApp} from "nuxt/app";

interface State {
    _currentUser: CurrentUser | null,
    _currentUserExtra: CurrentUser | null,
}

export interface CurrentUser {
    name?: string,
    email?: string,
    roles?: string[],
    id?: string,
    username?: string,
    readOnly?: boolean,
    tenancyRoles?: { [tenant: string]: string[] }
}

export const useAuthStore = defineStore('auth', {
    state: (): State => ({
        _currentUser: null,
        _currentUserExtra: null
    }),

    getters: {
        currentUser: (state) => state._currentUser,
        currentUserExtra: (state) => state._currentUserExtra,
        isCurrentUserUser: (state) => state._currentUser?.roles?.includes('USER'),
        isCurrentUserAdmin: (state) => state._currentUser?.roles?.includes('ADMIN'),
        isCurrentUserDbOwner: (state) => state._currentUser?.roles?.includes('DB_OWNER'),
        isCurrentUserSuperAdmin: (state) => state._currentUser?.roles?.includes('SUPER_ADMIN'),
        isCurrentUserAnyAdmin: (state) => {
            const roles = state._currentUser?.roles;
            return roles?.includes('SUPER_ADMIN') || roles?.includes('ADMIN');
        },
        isCurrentUserInactive: (state) => state._currentUserExtra?.readOnly ?? false,
        isCurrentUserAnonymous: (state) => (state._currentUser as any)?.name?.trim() === 'anonym anonym',
    },

    actions: {
        async setUser(user: any) {
            this.$state._currentUser = user;

            const {$customerStore, $organisationStore} = useNuxtApp();
            await $customerStore.getCurrentCustomer();
            if (!!$customerStore.currentCustomer.organisation) {
                $organisationStore.getCurrentOrganisation();
            }
            let newUser : CurrentUser = {...user, readOnly: false}
            newUser.readOnly = $customerStore.currentCustomer.readOnly;
            this.$state._currentUserExtra = newUser;
            return;
        },
        async updateUser() {
            const csrfToken = await useAuth().getCsrfToken();


            // nuxt-auth does not offer any way to do this POST request
            await $fetch('/api/auth/session', {
                method: 'POST',
                body: {
                    csrfToken: csrfToken
                }
            })

            // update session from state
            await useAuth().getSession();
            // console.log('user', useAuth().data.value?.user)
            let updateUser = {}

            if (<CurrentUser>useAuth().data.value?.user) {
                updateUser = JSON.parse(JSON.stringify(<CurrentUser>useAuth().data.value?.user))
            }

            this.$state._currentUser = updateUser;
            const {$customerStore, $organisationStore} = useNuxtApp();
            await $customerStore.getCurrentCustomer();
            if (!!$customerStore.currentCustomer.organisation) {
                $organisationStore.getCurrentOrganisation();
            }
            (<any>updateUser).readOnly = $customerStore.currentCustomer.readOnly;
            this.$state._currentUserExtra = updateUser;
        }
    }
})
